import { __assign, __spreadArray, __read } from 'tslib';
import { assign } from '@xstate/immer';
import { actions as actions$1 } from 'xstate';

var choose = actions$1.choose;
var traverse = function (nodes, options) {
    if (options === void 0) { options = {}; }
    var _a = options || {}, _b = _a.isRootLevel, isRootLevel = _b === void 0 ? true : _b, nodeFunc = _a.nodeFunc, nodeParentFunc = _a.nodeParentFunc, parentNode = _a.parentNode, _c = _a.showAll, showAll = _c === void 0 ? true : _c;
    nodes.forEach(function (node) {
        var _a;
        if (isRootLevel) {
            nodeParentFunc === null || nodeParentFunc === void 0 ? void 0 : nodeParentFunc(undefined);
        }
        if (parentNode) {
            nodeParentFunc === null || nodeParentFunc === void 0 ? void 0 : nodeParentFunc(parentNode);
        }
        nodeFunc === null || nodeFunc === void 0 ? void 0 : nodeFunc(node);
        if (showAll || node.expanded) {
            if ((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) {
                traverse(node.children, __assign(__assign({}, options), { isRootLevel: false, parentNode: node }));
            }
        }
    });
};
function getNodeOrder(nodes) {
    var visibleNodes = [];
    traverse(nodes, {
        showAll: false,
        nodeFunc: function (node) { return visibleNodes.push(node.id); },
    });
    return visibleNodes;
}
var checkNodeHasChildren = function (ctx) {
    var _a, _b;
    return Boolean((_b = (_a = ctx.activeNode) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length);
};
var checkNodeChildrenVisible = function (ctx) {
    var _a;
    return Boolean((_a = ctx.activeNode) === null || _a === void 0 ? void 0 : _a.expanded);
};
var toggleNodeChildren = function (nodes, value) {
    return nodes.map(function (node) {
        var _a, _b;
        var match = node.id === value;
        if (match && ((_a = node.children) === null || _a === void 0 ? void 0 : _a.length)) {
            return __assign(__assign({}, node), { expanded: !node.expanded });
        }
        if (!match && ((_b = node.children) === null || _b === void 0 ? void 0 : _b.length)) {
            return __assign(__assign({}, node), { children: toggleNodeChildren(__spreadArray([], __read(node.children), false), value) });
        }
        return node;
    });
};
var findNode = function (nodes, value) {
    var node;
    var parentNode;
    var setNode = function (_node) {
        // if it's a match assign it
        if (_node.id === value) {
            node = _node;
        }
    };
    var setParentNode = function (_parentNode) {
        if (!node) {
            parentNode = _parentNode;
        }
    };
    traverse(nodes, {
        showAll: false,
        nodeFunc: setNode,
        nodeParentFunc: setParentNode,
    });
    return { node: node, parentNode: parentNode };
};
var moveActiveNode = function (ctx, direction) {
    var _a, _b;
    if (direction === void 0) { direction = "up"; }
    var active = ctx.activeNode;
    var directionValue = direction === "up" ? -1 : 1;
    if (!active)
        return;
    var activeIdx = (_a = ctx.nodeOrder) === null || _a === void 0 ? void 0 : _a.findIndex(function (value) { return value === active.id; });
    if (activeIdx === undefined || activeIdx === -1)
        return;
    var nextNodeId = (_b = ctx.nodeOrder) === null || _b === void 0 ? void 0 : _b[activeIdx + directionValue];
    if (!nextNodeId)
        return;
    return findNode(ctx.nodes, nextNodeId);
};
var actions = {
    moveActiveNodeDown: assign(function (ctx) {
        var _a;
        var results = moveActiveNode(ctx, "down");
        if ((_a = results === null || results === void 0 ? void 0 : results.node) === null || _a === void 0 ? void 0 : _a.id) {
            ctx.activeNode = results.node;
            ctx.activeParentNode = results.parentNode;
        }
    }),
    moveActiveNodeUp: assign(function (ctx) {
        var _a;
        var results = moveActiveNode(ctx, "up");
        if ((_a = results === null || results === void 0 ? void 0 : results.node) === null || _a === void 0 ? void 0 : _a.id) {
            ctx.activeNode = results.node;
            ctx.activeParentNode = results.parentNode;
        }
    }),
    setDefaultActiveNode: assign(function (ctx) {
        if (ctx.activeNode)
            return;
        ctx.activeNode = ctx.nodes[0];
    }),
    setActiveNode: assign(function (ctx, event) {
        var _a;
        var value = event.currentTarget.dataset.value;
        if (((_a = ctx.activeNode) === null || _a === void 0 ? void 0 : _a.id) !== value) {
            var _b = findNode(ctx.nodes, value), node = _b.node, parentNode = _b.parentNode;
            if ((node === null || node === void 0 ? void 0 : node.id) && !node.disabled) {
                ctx.activeNode = node;
                ctx.activeParentNode = parentNode;
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }),
    setChildToActive: assign(function (ctx) {
        var _a;
        var active = ctx.activeNode;
        if (!active)
            return;
        if (!((_a = active === null || active === void 0 ? void 0 : active.children) === null || _a === void 0 ? void 0 : _a.length))
            return;
        ctx.activeNode = active.children[0];
        ctx.activeParentNode = active;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }),
    setParentToActive: assign(function (ctx) {
        var parent = ctx.activeParentNode;
        if (!parent)
            return;
        var _a = findNode(ctx.nodes, parent.id), node = _a.node, parentNode = _a.parentNode;
        ctx.activeNode = node;
        ctx.activeParentNode = parentNode;
    }),
    toggleChildren: assign(function (ctx) {
        var _a;
        var active = ctx.activeNode;
        if (!active || !((_a = active.children) === null || _a === void 0 ? void 0 : _a.length))
            return;
        ctx.nodes = toggleNodeChildren(ctx.nodes, active.id);
        ctx.activeNode = __assign(__assign({}, active), { expanded: !active.expanded });
    }),
    setNodeOrder: assign(function (ctx) {
        ctx.nodeOrder = getNodeOrder(ctx.nodes);
    }),
    setNodes: assign(function (ctx, event) {
        ctx.activeNode = undefined;
        ctx.nodes = event.nodes;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }),
    moveActiveToFirst: assign(function (ctx) {
        var _a;
        if (!ctx.nodeOrder)
            return;
        var firstId = ctx.nodeOrder[0];
        var results = findNode(ctx.nodes, firstId);
        if ((_a = results === null || results === void 0 ? void 0 : results.node) === null || _a === void 0 ? void 0 : _a.id) {
            ctx.activeNode = results.node;
            ctx.activeParentNode = results.parentNode;
        }
    }),
    moveActiveToLast: assign(function (ctx) {
        var _a, _b;
        if (!((_a = ctx.nodeOrder) === null || _a === void 0 ? void 0 : _a.length))
            return;
        var lastId = ctx.nodeOrder[ctx.nodeOrder.length - 1];
        var results = findNode(ctx.nodes, lastId);
        if ((_b = results === null || results === void 0 ? void 0 : results.node) === null || _b === void 0 ? void 0 : _b.id) {
            ctx.activeNode = results.node;
            ctx.activeParentNode = results.parentNode;
        }
    }),
    rightKeyPressed: choose([
        {
            cond: function (ctx) {
                return Boolean(checkNodeHasChildren(ctx) && !checkNodeChildrenVisible(ctx));
            },
            actions: ["toggleChildren", "setNodeOrder"],
        },
        {
            cond: function (ctx) {
                return Boolean(checkNodeHasChildren(ctx) && checkNodeChildrenVisible(ctx));
            },
            actions: ["setChildToActive"],
        },
    ]),
    leftKeyPressed: choose([
        {
            cond: function (ctx) {
                var _a;
                return Boolean(((_a = ctx.activeParentNode) === null || _a === void 0 ? void 0 : _a.expanded) && !checkNodeChildrenVisible(ctx));
            },
            actions: ["setParentToActive"],
        },
        {
            cond: function (ctx) {
                return Boolean(checkNodeChildrenVisible(ctx));
            },
            actions: ["toggleChildren", "setNodeOrder"],
        },
    ]),
};

export { actions, traverse };
//# sourceMappingURL=actions.js.map
